// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMessageListBody = {
  chatId: string;
  cursor?: string | null;
  limit?: number | null;
};

export type typeMessageListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      messageId: string;
      senderId: string;
      senderDisplayName: string;
      senderAvatarUrl?: string | null;
      kind:
        | "text"
        | "image"
        | "gif"
        | "poll"
        | "gameCard"
        | "systemAnnouncement"
        | "pdf";
      body?: string | null;
      mediaObjectIds?: string[] | null;
      gifObjectId?: string | null;
      replyToMessageId?: string | null;
      replyToPreview?: string | null;
      isEdited: boolean;
      isPinned: boolean;
      isDeleted: boolean;
      sentAtIso: string;
      editedAtIso?: string | null;
      reactions: { emoji: string; count: number; reactedByMe: boolean }[];
      poll?: {
        question: string;
        allowMultiple: boolean;
        options: { optionId: string; label: string; voteCount: number }[];
        myVoteOptionIds: string[];
        totalVotes: number;
      } | null;
      gameCard?: {
        eventId: string;
        capturedAtIso: string;
        leagueName: string;
        statusLabel: string;
        home: {
          teamId: string;
          name: string;
          abbreviation: string;
          logoMediaId?: string | null;
          score?: number | null;
        };
        away: {
          teamId: string;
          name: string;
          abbreviation: string;
          logoMediaId?: string | null;
          score?: number | null;
        };
        kickoffAtIso: string;
        deepLink: string;
      } | null;
      announcementKind?:
        | "settingsChanged"
        | "contestStarted"
        | "seasonStarted"
        | "squaresStarted"
        | "stripCardStarted"
        | "bracketStarted"
        | "revived"
        | "medalAwarded"
        | "trophyAwarded"
        | "customAwardGiven"
        | "customAwardRevoked"
        | "customAwardTypeDeleted"
        | "customAwardTypeArchived"
        | "winnerAppointed"
        | "memberJoined"
        | "correctionApplied"
        | null;
      pdf?: { fileName: string; byteSize?: number | null } | null;
      linkPreview?: {
        url: string;
        title: string;
        description?: string | null;
        siteName?: string | null;
        hostname: string;
      } | null;
    }[];
    nextCursor?: string | null;
    refreshAfterSeconds: number;
  };
};

export type typeMessageListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMessageListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMessageListBody = {
  type: "object",
  properties: {
    chatId: { type: "string", maxLength: 3000, minLength: 1 },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["chatId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMessageList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMessageListBody);
  }

  return async function postMessageList(
    payload: typeMessageListBody,
  ): Promise<typeMessageListOutput200 | typeMessageListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMessageList" failed before calling the network. #ff694e2856fe`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#ff694e2856fe" },
        },
        data: null,
      } as typeMessageListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/message/list`,
      httpMethod: "POST",
      options,
    })) as typeMessageListOutput200 | typeMessageListOutput400;
  };
}
